import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import userService from 'services/user'

import { selectCurrentUser } from 'store/global'

export function usePermissions() {
  const currentUser = useSelector(selectCurrentUser)

  const [permissions, setPermissions] = useState({
    isInitialized: false,
  })

  useEffect(() => {

    const isAdmin = userService.isAdmin(currentUser)
    const isSuperuser = userService.isSuperuser(currentUser)
    
    setPermissions({
      isInitialized: true,
      basicUserOnly: userService.isBasicUser(currentUser),
      basicUser: userService.isBasicUser(currentUser) || isAdmin || isSuperuser,
      admin: isAdmin,
      superuser: isSuperuser || isAdmin,
    })
  }, [currentUser])

  return permissions
}
